import Footer from "../components/Footer";
import Header from "../components/Header";

const UuDaiPhucLoi = () => {
  return (
    <div className="wrapper">
      <div className="container-web uudaiphucloi bgnew">
        <Header title="Các ưu đãi" />

        <main className="px-3">
          <p>
            • Sử dụng thẻ thành viên VIP: Nhận siêu giải thưởng ưu đãi giảm giá
            khi mua bất động sản của tập đoàn DOJI hoặc các dự án Vinhomes, các
            dòng xe của VinFast... Thời gian sử dụng: Từ 1 đến 5 năm miễn phí
            tùy theo hạn mức tham gia đầu tư của khách hàng, nhận siêu ưu đãi
            giảm giá từ 5% đến 30%. Khách hàng đăng ký thành công tham gia trái
            phiếu tiết kiệm nhận thẻ cổ phần phổ thông giảm giá các sản phẩm của
            Tập Đoàn DOJI. Điền thông tin được in trên thẻ thành viên miễn phí
            không cần cọc.
          </p>

          <p>
            • Khách hàng tạo tài khoản không thực hiện giao dịch kích hoạt tài
            khoản thì sau 24-72 tiếng tài khoản sẽ tự động vô hiệu hóa.
          </p>

          <p>
            Ngoài ra: Tập đoàn đang triển khai chương trình ưu đãi hỗ trợ cho
            quý khách hàng tham gia gửi trái phiếu tiết kiệm 1 phần quà giảm giá
            từ 20-50% bao gồm tất cả sản phẩm trang sức vàng bạc đá quý trên
            trang chủ của tập đoàn :
          </p>

          <p>
            <a
              style={{ color: "#2880b9", textDecoration: "none" }}
              href="https://trangsuc.doji.vn/"
            >
              https://trangsuc.doji.vn/
            </a>{" "}
            <span style={{ color: "#e74c3c" }}>
              (Lưu ý: Chương trình chỉ hỗ trợ trong trường hợp quý khách quy đổi
              từ tiền thưởng và lợi nhuận trái phiếu sang các sản phẩm trang sức
              của tập đoàn)
            </span>
          </p>

          <p>
            <span style={{ color: "#e74c3c" }}>
              *Thành viên tham gia gửi tiết kiệm trái phiếu nội bộ chỉ áp dụng
              cho mã mời số hiệu là DOJI.
            </span>
          </p>

          <div className="border-top">
            <div style={{ border: "2px solid #deaa4f" }}>
              <table className="table text-center m-0 table-top">
                <tbody>
                  <tr className="heading">
                    <td colSpan={3}>ƯU ĐÃI</td>
                  </tr>
                  <tr style={{ border: 0 }}>
                    <td colSpan={3} style={{ border: 0 }}>
                      <div className="d-flex">
                        <div className="nav-item text-start w-100">Số tiền</div>
                        <div className="nav-item text-center w-100">
                          Phần thưởng
                        </div>
                        <div className="nav-item text-end w-100">Lợi nhuận</div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table className="table table-borderless table-bottom m-0">
                <tbody>
                  <tr>
                    <td colSpan={2} style={{ width: "88%" }}>
                      <strong>Ưu đãi</strong>
                      <div>
                        <p>
                          Nhận 1 thẻ BHYT áp dụng cho tất cả cơ sở hệ thống bệnh
                          viện đa khoa quốc tế VINMEC. 1 thẻ tín dụng TP Bank
                          Visa SILVER với hạn mức tối đa là 100.000.000 VND.
                          Ngoài ra quý khách sẽ được tặng 1 voucher miễn phí bất
                          kì trang sức tự chọn tại trang{" "}
                          <strong>
                            <span style={{ fontSize: 18 }}>
                              <a href="https://trangsuc.doji.vn/">
                                <span style={{ color: "#2880b9" }}>
                                  https://trangsuc.doji.vn/
                                </span>
                              </a>
                            </span>
                          </strong>{" "}
                          với giá trị tối đa là 30.000.000 VND !<br />
                          <img
                            src="https://tpb.vn/wps/wcm/connect/899eef7e-2f48-4571-b27f-b6cc6bf517a3/Silver%282%29.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE-899eef7e-2f48-4571-b27f-b6cc6bf517a3-o.rZIAf"
                            alt="Mở thẻ tín dụng quốc tế online - Thỏa sức chi tiêu cùng TPBank"
                          />
                        </p>
                      </div>
                    </td>
                    <td style={{ width: "12%" }} className="text-center">
                      <span
                        className="status-icon"
                        style={{ background: "rgb(163, 163, 163)" }}
                      />
                      800 Triệu
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ width: "88%" }}>
                      <strong>Ưu đãi</strong>
                      <div>
                        <p>
                          Nhận 1 voucher giảm 10% khi mua các căn hộ dự án bất
                          động sản của tập đoàn DOJI hoặc các dự án Vinhomes, xe
                          Vinfast. 1 thẻ tín dụng TP Bank Visa SILVER với hạn
                          mức tối đa là 300.000.000 VND. Miễn phí 1 tour nghỉ
                          dưỡng 4 ngày 3 đêm cho 1 hộ gia đình tại khu du lịch
                          sinh thái Vinpearl bất kì trên toàn quốc. 1 thẻ VIP
                          BẠC của tập đoàn với đầy đủ chương trình ưu đãi ở toàn
                          bộ hệ thống của tập đoàn DOJI. Ngoài ra quý khách sẽ
                          được tặng 1 voucher miễn phí bất kì trang sức tự chọn
                          tại trang{" "}
                          <strong>
                            <span style={{ fontSize: 18 }}>
                              <a href="https://trangsuc.doji.vn/">
                                <span style={{ color: "#2880b9" }}>
                                  https://trangsuc.doji.vn/
                                </span>
                              </a>
                            </span>
                          </strong>{" "}
                          với giá trị tối đa là 50.000.000 VND !<br />
                          <br />
                        </p>
                        <p>
                          <img
                            src="https://product.hstatic.net/200000567741/product/afeb002118f2ha1_1_438c7a7e64f74db7a34abee158b1efca_1024x1024.jpg"
                            alt="Hoa tai vàng trắng 14K gắn kim cương DOJI AFEB002118F2HA1 "
                          />
                        </p>
                        <p>&nbsp;</p>
                      </div>
                    </td>
                    <td style={{ width: "12%" }} className="text-center">
                      <span
                        className="status-icon"
                        style={{ background: "rgb(163, 163, 163)" }}
                      />
                      1.5 Tỷ
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ width: "88%" }}>
                      <strong>Ưu đãi</strong>
                      <div>
                        <p>
                          Nhận 1 voucher giảm 15% khi mua các căn hộ dự án bất
                          động sản của tập đoàn DOJI hoặc các dự án Vinhomes, xe
                          Vinfast. 1 thẻ tín dụng TP Bank Visa GOLD với hạn mức
                          tối đa là 600.000.000 VND. Miễn phí 1 tour nghỉ dưỡng
                          7 ngày 6 đêm cho 1 hộ gia đình tại khu du lịch sinh
                          thái Vinpearl bất kì trên toàn quốc. 1 thẻ VIP VÀNG
                          của tập đoàn với đầy đủ chương trình ưu đãi ở toàn bộ
                          hệ thống của tập đoàn DOJI. Ngoài ra quý khách sẽ được
                          tặng 1 voucher miễn phí bất kì trang sức tự chọn tại
                          trang{" "}
                          <strong>
                            <span style={{ fontSize: 18 }}>
                              <a href="https://trangsuc.doji.vn/">
                                <span style={{ color: "#2880b9" }}>
                                  https://trangsuc.doji.vn/
                                </span>
                              </a>
                            </span>
                          </strong>{" "}
                          với giá trị tối đa là 70.000.000 VND !
                        </p>
                        <p>
                          <img
                            src="https://tpb.vn/wps/wcm/connect/23b0e28c-f3d2-47aa-8c50-3a0762105c38/Gold.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE-23b0e28c-f3d2-47aa-8c50-3a0762105c38-o.rZElS"
                            alt="Mở thẻ tín dụng quốc tế online - Thỏa sức chi tiêu cùng TPBank"
                          />
                        </p>
                      </div>
                    </td>
                    <td style={{ width: "12%" }} className="text-center">
                      <span
                        className="status-icon"
                        style={{ background: "rgb(163, 163, 163)" }}
                      />
                      3 Tỷ
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ width: "88%" }}>
                      <strong>Ưu đãi</strong>
                      <div>
                        <p>
                          Nhận 1 voucher giảm 20% khi mua các căn hộ dự án bất
                          động sản của tập đoàn DOJI hoặc các dự án Vinhomes, 01
                          xe điện Vinfast VF3 trị giá 315.000.000VND. 1 thẻ tín
                          dụng TP Bank Visa GOLD với hạn mức tối đa là
                          1.000.000.000 VND. Miễn phí 1 tour nghỉ dưỡng 10 ngày
                          9 đêm cho 1 hộ gia đình tại khu du lịch sinh thái
                          Vinpearl bất kì trên toàn quốc. 1 thẻ VIP BẠCH KIM của
                          tập đoàn với đầy đủ chương trình ưu đãi ở toàn bộ hệ
                          thống của tập đoàn DOJI. Ngoài ra quý khách sẽ được
                          tặng 1 voucher miễn phí bất kì trang sức tự chọn tại
                          trang{" "}
                          <strong>
                            <span style={{ fontSize: 18 }}>
                              <a href="https://trangsuc.doji.vn/">
                                <span style={{ color: "#2880b9" }}>
                                  https://trangsuc.doji.vn/
                                </span>
                              </a>
                            </span>
                          </strong>{" "}
                          với giá trị tối đa là 90.000.000 VND !
                        </p>
                        <p>
                          <img
                            src="https://media.auto5.vn/files/quanganh/2024/08/05/htt08283-201739.jpg"
                            alt="Hé lộ giá bán bộ sạc xe điện VinFast VF 3 tại nhà"
                          />
                        </p>
                        <p>&nbsp;</p>
                        <p>
                          <br />
                          Hiện tại dự án Vinhomes Cổ Loa Hà Nội đang có sự kiện
                          dành cho khách hàng mới tham gia trái phiếu tiết kiệm
                          dự án Tập đoàn DOJI. Khi khách hàng tham gia đặt lịch
                          gói 7 tỷ ngoài thưởng đặt lịch quý khách còn nhận cơ
                          hội bốc thăm 3 căn Hoa Hậu tại dự án Vinhomes Cổ Loa
                          Hà Nội, 01 Cây vàng SJC 9999.
                        </p>
                      </div>
                    </td>
                    <td style={{ width: "12%" }} className="text-center">
                      <span
                        className="status-icon"
                        style={{ background: "rgb(163, 163, 163)" }}
                      />
                      7 Tỷ
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ width: "88%" }}>
                      <strong>Ưu đãi</strong>
                      <div>
                        <p>
                          Nhận 1 voucher giảm 25% khi mua các căn hộ dự án bất
                          động sản của tập đoàn DOJI hoặc các dự án Vinhomes, 01
                          xe điện Vinfast VF7 trị giá 999.000.000VND. 1 thẻ tín
                          dụng TP Bank Visa PLATINUM với hạn mức tối đa là
                          2.000.000.000 VND. Miễn phí 1 tour nghỉ dưỡng 15 ngày
                          cho 1 hộ gia đình tại 3 nước Châu Á. 1 thẻ VIP KIM
                          CƯƠNG của tập đoàn với đầy đủ chương trình ưu đãi ở
                          toàn bộ hệ thống của tập đoàn DOJI. Ngoài ra quý khách
                          sẽ được tặng 1 voucher miễn phí bất kì trang sức tự
                          chọn tại trang{" "}
                          <strong>
                            <span style={{ fontSize: 18 }}>
                              <a href="https://trangsuc.doji.vn/">
                                <span style={{ color: "#2880b9" }}>
                                  https://trangsuc.doji.vn/
                                </span>
                              </a>
                            </span>
                          </strong>{" "}
                          với giá trị tối đa là 120.000.000 VND. Một viên kim
                          cương tự nhiên trị giá 25.000USD !
                        </p>
                        <p>
                          <img
                            src="https://tpb.vn/wps/wcm/connect/3c25b742-c098-4b9e-80fe-820266039cdb/Platinum.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE-3c25b742-c098-4b9e-80fe-820266039cdb-o.rZz2S"
                            alt="Mở thẻ tín dụng quốc tế online - Thỏa sức chi tiêu cùng TPBank"
                          />
                        </p>
                        <p>
                          Hiện tại dự án Vinhomes Cổ Loa Hà Nội đang có sự kiện
                          dành cho khách hàng mới tham gia trái phiếu tiết kiệm
                          dự án Tập đoàn DOJI. Khi khách hàng tham gia đặt lịch
                          gói 16 tỷ ngoài thưởng đặt lịch quý khách còn nhận cơ
                          hội bốc thăm 3 căn Hoa Hậu tại dự án Vinhomes Cổ Loa
                          Hà Nội, 02 Cây vàng SJC 9999.
                        </p>
                      </div>
                    </td>
                    <td style={{ width: "12%" }} className="text-center">
                      <span
                        className="status-icon"
                        style={{ background: "rgb(163, 163, 163)" }}
                      />
                      16 Tỷ
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ width: "88%" }}>
                      <strong>Ưu đãi</strong>
                      <div>
                        <p>
                          Nhận 1 voucher giảm 30% khi mua các căn hộ dự án bất
                          động sản của tập đoàn DOJI hoặc các dự án Vinhomes, 01
                          xe điện Vinfast VF8 trị giá 1.375.000.000VND. 1 thẻ
                          tín dụng TP Bank Visa PLATINUM với hạn mức tối đa là
                          3.000.000.000 VND. Miễn phí 1 tour nghỉ dưỡng 30 ngày
                          cho 1 hộ gia đình tại 3 nước Châu Á. 1 thẻ VIP KIM
                          CƯƠNG của tập đoàn với đầy đủ chương trình ưu đãi ở
                          toàn bộ hệ thống của tập đoàn DOJI. Ngoài ra quý khách
                          sẽ được tặng 1 voucher miễn phí bất kì trang sức tự
                          chọn tại trang{" "}
                          <strong>
                            <span style={{ fontSize: 18 }}>
                              <a href="https://trangsuc.doji.vn/">
                                <span style={{ color: "#2880b9" }}>
                                  https://trangsuc.doji.vn/
                                </span>
                              </a>
                            </span>
                          </strong>{" "}
                          với giá trị tối đa là 150.000.000 VND. Một viên kim
                          cương tự nhiên trị giá 50.000USD !<br />
                          <img
                            src="https://i.ex-cdn.com/vietnamfinance.vn/files/f1/news/ledinhnga/2022/1/6/VNF-vinfast-vf8-gia-hon-1ty-dong-tai-VN.jpg"
                            alt="Giá xe VinFast VF8 hơn 1 tỷ, VF9 gần 1,6 tỷ đồng tại thị trường Việt Nam"
                          />
                        </p>
                        <p>
                          Hiện tại dự án Vinhomes Cổ Loa Hà Nội đang có sự kiện
                          dành cho khách hàng mới tham gia trái phiếu tiết kiệm
                          dự án Tập đoàn DOJI. Khi khách hàng tham gia đặt lịch
                          gói 25 tỷ ngoài thưởng đặt lịch quý khách còn nhận cơ
                          hội bốc thăm 3 căn Hoa Hậu tại dự án Vinhomes Cổ Loa
                          Hà Nội, 03 Cây vàng SJC 9999.
                        </p>
                      </div>
                    </td>
                    <td style={{ width: "12%" }} className="text-center">
                      <span
                        className="status-icon"
                        style={{ background: "rgb(163, 163, 163)" }}
                      />
                      25 Tỷ
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ width: "88%" }}>
                      <strong>Ưu đãi</strong>
                      <div>
                        <p>
                          Nhận 2 voucher giảm 30% khi mua căn hộ Vinhomes hoặc
                          01 xe điện Vinfast VF9 trị giá 2.312.000.000VND. 1 thẻ
                          tín dụng TP Bank WORLD MASTERCARD với hạn mức tối đa
                          là 5.000.000.000 VND. Miễn phí 1 tour du lịch 30 ngày
                          ở 5 nước Châu Âu. 1 thẻ VIP BLACK của tập đoàn với đầy
                          đủ chương trình ưu đãi ở toàn bộ hệ thống của tập đoàn
                          Vingroup. Ngoài ra quý khách sẽ được tặng 1 voucher
                          miễn phí bất kì trang sức tự chọn tại trang{" "}
                          <strong>
                            <span style={{ fontSize: 18 }}>
                              <a href="https://trangsuc.doji.vn/">
                                <span style={{ color: "#2880b9" }}>
                                  https://trangsuc.doji.vn/
                                </span>
                              </a>
                            </span>
                          </strong>{" "}
                          với giá trị tối đa là 200.000.000 VND, một suất học
                          bổng trường Harvard University tại USA miễn toàn bộ
                          học phí 2 năm và một viên kim cương tự nhiên trị giá
                          100,000$
                        </p>
                        <p>
                          <img src="https://tpb.vn/wps/wcm/connect/5cb6d509-9597-4f21-b8b5-040990d05622/ClubPrive.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE-5cb6d509-9597-4f21-b8b5-040990d05622-peUGpCj" />
                        </p>
                        <p>
                          Hiện tại dự án Vinhomes Cổ Loa Hà Nội đang có sự kiện
                          dành cho khách hàng mới tham gia trái phiếu tiết kiệm
                          dự án Tập đoàn DOJI. Khi khách hàng tham gia đặt lịch
                          gói 40 tỷ ngoài thưởng đặt lịch quý khách còn nhận cơ
                          hội bốc thăm 3 căn Hoa Hậu tại dự án Vinhomes Cổ Loa
                          Hà Nội, 05 Cây vàng SJC 9999.
                        </p>
                      </div>
                    </td>
                    <td style={{ width: "12%" }} className="text-center">
                      <span
                        className="status-icon"
                        style={{ background: "rgb(163, 163, 163)" }}
                      />
                      40 Tỷ
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ width: "88%" }}>
                      <strong>Ưu đãi</strong>
                      <div>
                        <p>
                          Tặng 01 căn chung cư cao cấp 2 phòng ngủ tại Royal
                          City Hà Nội. 1 thẻ tín dụng TP Bank WORLD MASTERCARD
                          với hạn mức tối đa là 7.000.000.000 VND. Miễn phí 2
                          tour du lịch 30 ngày ở 5 nước Châu Á và 30 ngày ở 5
                          nước Châu Âu. 1 thẻ VIP BLACK của tập đoàn với đầy đủ
                          chương trình ưu đãi ở toàn bộ hệ thống của tập đoàn
                          Vingroup. Ngoài ra quý khách sẽ được tặng 1 voucher
                          miễn phí bất kì trang sức tự chọn tại trang{" "}
                          <strong>
                            <span style={{ fontSize: 18 }}>
                              <a href="https://trangsuc.doji.vn/">
                                <span style={{ color: "#2880b9" }}>
                                  https://trangsuc.doji.vn/
                                </span>
                              </a>
                            </span>
                          </strong>{" "}
                          với giá trị tối đa là 250.000.000 VND, một suất học
                          bổng trường Harvard University tại USA miễn toàn bộ
                          học phí 4 năm và một viên kim cương tự nhiên trị giá
                          200,000$
                        </p>
                        <p>
                          <img
                            src="https://duanvinhomescoloa.vn/wp-content/uploads/2024/08/banner-co-loa-3.jpg"
                            alt="Vinhomes Cổ Loa Đông Anh - Thông Tin & Tiến Độ Mới Nhất 2024"
                          />
                        </p>
                        <p>
                          Hiện tại dự án Vinhomes Cổ Loa Hà Nội đang có sự kiện
                          dành cho khách hàng mới tham gia trái phiếu tiết kiệm
                          dự án Tập đoàn DOJI. Khi khách hàng tham gia đặt lịch
                          gói 40 tỷ ngoài thưởng đặt lịch quý khách còn nhận cơ
                          hội bốc thăm 3 căn Hoa Hậu tại dự án Vinhomes Cổ Loa
                          Hà Nội, 07 Cây vàng SJC 9999.
                        </p>
                      </div>
                    </td>
                    <td style={{ width: "12%" }} className="text-center">
                      <span
                        className="status-icon"
                        style={{ background: "rgb(163, 163, 163)" }}
                      />
                      60 Tỷ
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ width: "88%" }}>
                      <strong>Ưu đãi</strong>
                      <div>
                        <p>
                          Tặng 1 thẻ tín dụng TP Bank Visa SIGNATURE với hạn mức
                          tối đa là 10.000.000.000 VND và "trở thành cổ đông ưu
                          tiên của Tập đoàn với 0.005% lợi nhuận hàng tháng vĩnh
                          viễn".
                        </p>
                        <p>
                          <img
                            src="https://kinhteluatvcu.edu.vn/wp-content/uploads/2023/06/the-den-ngan-hang-tpbank.jpg"
                            alt="Điều Kiện, Hạn Mức Và Cách Mở Thẻ TPBank Visa Signature Online 2023"
                          />
                        </p>
                        <p>&nbsp;</p>
                        <p>
                          Hiện tại dự án Vinhomes Cổ Loa Hà Nội đang có sự kiện
                          dành cho khách hàng mới tham gia trái phiếu tiết kiệm
                          dự án Tập đoàn DOJI. Khi khách hàng tham gia đặt lịch
                          gói 40 tỷ ngoài thưởng đặt lịch quý khách còn nhận cơ
                          hội bốc thăm 3 căn Hoa Hậu tại dự án Vinhomes Cổ Loa
                          Hà Nội, 10 Cây vàng SJC 9999.
                        </p>
                      </div>
                    </td>
                    <td style={{ width: "12%" }} className="text-center">
                      <span
                        className="status-icon"
                        style={{ background: "rgb(163, 163, 163)" }}
                      />
                      90 Tỷ
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ width: "88%" }}>
                      <strong>Ưu đãi</strong>
                      <div>
                        <p>
                          Tặng 1 căn chung cư cao cấp 3 phòng ngủ tại Central
                          Park Hồ Chí Minh và "trở thành cổ đông của tập đoàn
                          với 0.01% lợi nhuận hàng tháng vĩnh viễn".
                        </p>
                        <p>
                          <img
                            src="https://file4.batdongsan.com.vn/2023/07/23/20230723153215-a842_wm.jpg"
                            alt="Vinhomes Central Park Tân Cảng | Giá Bán CĐT Cập Nhật T11/2024"
                          />
                        </p>
                      </div>
                    </td>
                    <td style={{ width: "12%" }} className="text-center">
                      <span
                        className="status-icon"
                        style={{ background: "rgb(163, 163, 163)" }}
                      />
                      150 Tỷ
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div style={{ paddingBottom: 120 }}></div>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default UuDaiPhucLoi;
